module.exports = __webpack_public_path__ + "static/media/twitter-circle.eb24ce23.svg";